import { FC } from 'react';
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions';
import { IconButton, useTheme, Tooltip } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

/**
 * @summary Упрощенный компонент для кнопок пагинации material-ui.
 * Необходимость в компоненте возникла из-за отсутствия возможности использовать
 * Стандартный Tooltip для подсказки у кнопок переключения страниц.
 */
export const CustomPaginationActions: FC<TablePaginationActionsProps> = ({
  className,
  backIconButtonProps,
  nextIconButtonProps,
  onPageChange,
  page,
  count,
  rowsPerPage,
}) => {
  const theme = useTheme();
  const backButtonDisabled = page === 0;
  const nextButtonDisabled = count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false;

  const handleBackButtonClick = (event: any) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: any) => {
    onPageChange(event, page + 1);
  };

  return (
    <div className={className}>
      <Tooltip title={backButtonDisabled ? '' : backIconButtonProps?.title || ''}>
        <span>
          <IconButton
            onClick={handleBackButtonClick}
            disabled={backButtonDisabled}
            color="inherit"
            {...backIconButtonProps}
          >
            {theme.direction === 'rtl' ? <NavigateNextIcon /> : <NavigateBeforeIcon />}
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={nextButtonDisabled ? '' : nextIconButtonProps?.title || ''}>
        <span>
          <IconButton
            onClick={handleNextButtonClick}
            disabled={nextButtonDisabled}
            color="inherit"
            {...nextIconButtonProps}
          >
            {theme.direction === 'rtl' ? <NavigateBeforeIcon /> : <NavigateNextIcon />}
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
};
